import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { TabNavigationItem } from '@app/navigation/navigation.model';
import { TabNavigationService } from '@app/navigation/components/tab-navigation/tab-navigation.service';

@Component({
  selector: 'dgx-user-settings-nav',
  templateUrl: './user-settings-nav.component.html',
})
export class UserSettingsNavComponent implements OnInit {
  public i18n = this.translate.instant([
    'A11y_SecondaryPagesNavType',
    'User_Profile',
    'User_Account',
    'User_Communications',
    'User_Integrations',
    'User_Extensions',
    'User_Family',
  ]);

  @Input() public hideExtension?: boolean = true;
  @Input() public hideIntegrationsTab?: boolean = true;
  @Input() public isClientProvider?: boolean = false;
  @Input() public hasSocialIntegrations?: boolean = false;
  @Input() public showFamily?: boolean = false;

  public selectedTab: string = 'profile';
  public tabs = new Set<string>(['profile', 'account', 'communications']);
  public tabList: TabNavigationItem[] = [];

  constructor(
    private location: Location,
    private translate: TranslateService,
    private tabNavigationService: TabNavigationService
  ) {}

  public ngOnInit(): void {
    this.tabList = this.getTabs();

    const url = this.location.path();
    this.selectedTab = url
      .split('/')
      .filter((e) => e)
      .slice(-1)[0];
  }

  /**
   * Get the secondary tab navigation
   * @returns list of tabs to display
   */
  private getTabs(): TabNavigationItem[] {
    const tabs: TabNavigationItem[] = [
      {
        dgat: 'Settings-592',
        routerLink: 'profile',
        label: this.i18n.User_Profile,
      },
      {
        dgat: 'Settings-f6d',
        routerLink: 'account',
        label: this.i18n.User_Account,
      },
      {
        dgat: 'Settings-b94',
        routerLink: 'communications',
        label: this.i18n.User_Communications,
      },
    ];

    if (
      !this.isClientProvider &&
      !this.hideIntegrationsTab &&
      this.hasSocialIntegrations
    ) {
      tabs.push({
        dgat: 'Settings-a70',
        routerLink: 'integrations',
        label: this.i18n.User_Integrations,
      });
    }
    if (!this.hideExtension) {
      tabs.push({
        dgat: 'Settings-58e',
        routerLink: 'extensions',
        label: this.i18n.User_Extensions,
      });
    }
    if (this.showFamily) {
      tabs.push({
        dgat: 'Settings-dc6',
        routerLink: 'family',
        label: this.i18n.User_Family,
      });
    }

    return this.tabNavigationService.formatTabs(tabs);
  }
}
